module.exports = __webpack_public_path__ + "img/logo_horizontal.8f0e82f5.svg";